// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chat-style-comment-linked-entry[data-v-b7a3c78a]{margin:15px}.chat-style-comment-linked-entry__text[data-v-b7a3c78a]{font-size:16px}.chat-style-comment-linked-entry__text_white[data-v-b7a3c78a]{color:#fff}.chat-style-comment-linked-entry__text_white[data-v-b7a3c78a] a{color:#fff !important}\n", ""]);
// Exports
module.exports = exports;
